import { ApprovalState } from 'borispage/common/AdminCommonComponents';
import { PopFeedbackList } from 'ctls/popup/PopFeedbackList';
import { AdmissionType, getAdmissionTypeLangKey } from 'definitions/AdmissionType';
import { doc_ro, docwriteutil } from 'docwrite/community/common/docwriteutil';
import { useLoginUtil } from 'hooks/useLoginInfo';
import { useTrans } from 'hooks/useTrans';
import img_view_icon_angry from 'images/common/icon_angry_16.svg';
import img_view_icon_alarm from 'images/common/icon_feed_alarm.svg';
import img_view_icon_smile from 'images/common/icon_smile_16.svg';
import { SsqImages } from 'images/SsqImages';
import { useRef } from 'react';
import { ISsqDataDocumentAdminPopup } from 'repositories/SsqDataRepository';
import { InputWrapFortoggle } from 'style/CommonStyledComponents';
import styled from 'styled-components';
import useSWR from 'swr';
import { docutil } from 'util/docutil';
import { IconBtn } from '../common/IconBtn';
import { useZstdDocWrite } from '../common/useZstdDocWrite';
import { usePopDocGrpSett } from '../docgrp/PopDocGrpSett';
import { useApiDocGrp } from '../docgrp/useApiDocGrp';

type Props = {};

/**
 * 문서 상태, 공개 상태.
 */
export const DocWriteTopRow1 = (props: Props) => {
  const zstd = useZstdDocWrite();
  const { inputDoc, setInputDoc, pageType } = zstd;
  const feedback = useRef(null);
  const trans = docwriteutil.getadmintrans;
  const loginutil = useLoginUtil();
  const { tadmin } = useTrans();
  const roPublic = doc_ro(inputDoc.id, pageType, 'public');

  const [popDocGrpSett, PopDocGrpSett] = usePopDocGrpSett();

  const { data: docGrpId } = useSWR(
    inputDoc?.id && ['/api//member/zdata/docgrpmppng/grpidbydocid', { docId: inputDoc.id }]
  );

  const { diffLevel } = useApiDocGrp(docGrpId);

  return (
    <>
      {loginutil.allowTopRow1() ? (
        <Body className={'approval_row flex_row approval_row_shadow'}>
          <InputWrapFortoggle>
            <div className={'approval_tit'}>{trans('I18N_FILTER_EXPOSE_STATE')}</div>
            <input
              aria-label='checkbox-expose'
              type={'checkbox'}
              id={'toggle'}
              checked={!inputDoc.expose}
              readOnly={roPublic}
              onChange={() => !roPublic && setInputDoc((doc) => ({ ...doc, expose: !inputDoc.expose }))}
            />
            <label htmlFor={'toggle'}>{trans(inputDoc.expose ? 'I18N_FILTER_EXPOSE' : 'I18N_FILTER_NOT_EXPOSE')}</label>
          </InputWrapFortoggle>
          <div className={'approval_state'}>
            <div className={'discontinue'}>
              <input
                type={'checkbox'}
                id={'discontinue'}
                checked={inputDoc.discontinue}
                readOnly={roPublic}
                onChange={() => !roPublic && setInputDoc((doc) => ({ ...doc, discontinue: !inputDoc.discontinue }))}
                className={'approval_tit'}
              />
              <label htmlFor={'discontinue'}>{tadmin('I18N_SUBJECT_DISCONTINUE')}</label>
            </div>
            <div className={'ml-2 flex items-center'}>
              <span className={'ml-2'}>문서번호</span>
              <span className={'ml-2'}>{inputDoc.id ? inputDoc.id : '-'}</span>
              <span className={'ml-2'}>그룹번호</span>
              <span className={'ml-2'}>{docGrpId ? 'G-' + docGrpId : '-'}</span>
              <IconBtn
                iconType={'setting'}
                onClick={() => {
                  popDocGrpSett.current.show({ docGrpId, docId: inputDoc.id });
                }}
                className='ml-2'
              />
              {docGrpId && (
                <DocStatus className={diffLevel}>
                  {['Similar', 'Different'].includes(diffLevel) ? '불일치' : '일치'}
                </DocStatus>
              )}
            </div>
          </div>
          <div className={'approval_state'}>
            <div className={'approval_tit'}>{trans('I18N_FILTER_DOC_STATE')}</div>
            {inputDoc.id ? (
              docutil.approvalRequried(inputDoc.docType) ? (
                <AdmissionDoc trans={trans} inputDoc={inputDoc} />
              ) : (
                <NotAdmissionDoc inputDoc={inputDoc} />
              )
            ) : (
              '-'
            )}
          </div>
          {/*피드백*/}
          <div className={'approval_state'}>
            <div className={'approval_tit'}>{trans('I18N_ADMIN_CMMNTY_FEEDBACK')}</div>
            <FeedbackCell>
              <div className={'td-icon'}>
                <img
                  onClick={() => {
                    feedback.current.show({ docId: inputDoc.id });
                  }}
                  src={SsqImages.boris.allMappedFeedbacks()}
                  alt={'all_mapped_feedbacks.svg'}
                />

                <img src={img_view_icon_smile} alt='' />
                <span className='txt-blue'>{inputDoc.goodCount || 0}</span>
                <img src={img_view_icon_angry} alt='' />
                <span className='txt-red'>{inputDoc.badCount || 0}</span>
                <img src={img_view_icon_alarm} alt='' />
                <span className='txt-red'>{inputDoc.reportedCnt || 0}</span>
              </div>
            </FeedbackCell>
          </div>
          <PopFeedbackList ref={feedback} />
          <PopDocGrpSett />
        </Body>
      ) : null}
    </>
  );
};

const DocStatus = styled.div`
  width: 7.1rem;
  height: 3.2rem;
  border-radius: 2rem;
  text-align: center;

  &.Same {
    background-color: #e8f5e9;
    border: 1px solid #4caf50;
    color: #4caf50;
  }
  &.Similar,
  &.Different {
    background-color: #e6003e1a;
    border: 1px solid #e6003e;
    color: #e6003e;
  }
`;

export const Body = styled.div`
  &&&& {
    // 첫번째행의 각 컬럼을 나타냄.
    > div:nth-child(1) {
      width: 25%;
    }

    > div:nth-child(2) {
      width: 30%;
    }

    > div:nth-child(3) {
      width: 20%;
    }

    > div:nth-child(4) {
      width: 25%;
    }

    input#discontinue {
      cursor: pointer;
      width: 3rem;
      min-width: 3rem;
    }

    .discontinue {
      display: flex;
      align-items: center;
    }
  }
`;

interface AdmissionDocProps {
  inputDoc: ISsqDataDocumentAdminPopup;
  trans;
}

const AdmissionDoc = ({ inputDoc, trans }: AdmissionDocProps) => {
  // const admission = inputDoc.admission as ADMISSION_TYPE;
  // if (admission === 'DELETED') {
  //   return <>
  //     <span><img alt={"delete-icon-gray.svg"} src={deleteIconGray}/></span>
  //     <span>{trans(getAdmissionTypeLangKey(inputDoc.admission))}</span>
  //     <span className={"name"}></span>
  //     <span className={"time"}>{formatDateTime(new Date(inputDoc.updateTime))}</span>
  //
  //   </>;
  // } else if (admission === 'DEL_REQUESTED') {
  //   return <>
  //     <span><img alt={"delete-icon-red.svg"} src={deleteIconRed}/></span>
  //     <span>{trans(getAdmissionTypeLangKey(inputDoc.admission))}</span>
  //     <span className={"name"}></span>
  //     <span className={"time"}>{formatDateTime(new Date(inputDoc.updateTime))}</span>
  //   </>;
  // }

  return (
    <>
      {(inputDoc.histories?.length > 0 && (
        <ApprovalState recentHistory={inputDoc.histories[0]} getTranslation={docwriteutil.getadmintrans} />
      )) || (
        <>
          {inputDoc.admission === AdmissionType.NOT_APPROVED && (
            <span>
              <img alt={'adm_not.svg'} src={SsqImages.common.icon.admissionnot()} />
            </span>
          )}
          <span>{trans(getAdmissionTypeLangKey(inputDoc.admission))}</span>
        </>
      )}
    </>
  );
};

interface NotAdmissionDocProps {
  inputDoc: ISsqDataDocumentAdminPopup;
}

const NotAdmissionDoc = ({ inputDoc }: NotAdmissionDocProps) => {
  return <>{docutil.getDocStat(inputDoc.docType, inputDoc.finished)}</>;
};

const FeedbackCell = styled.div`
  cursor: pointer;

  .td-icon {
    display: flex;
  }

  .td-icon > img {
    margin-right: 0.4rem;
    vertical-align: middle;
  }

  .td-icon > span {
    margin-right: 0.4rem;
  }
`;
